'use strict';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import * as XLSX from 'xlsx/xlsx';

export function convertToExcel(json) {
  if (isObject(json) && isArray(json.list) && json.list.length > 0) {
    const wb = {
      SheetNames: [],
      Sheets: {},
    };

    const ws = XLSX.utils.json_to_sheet(json.list, {
      header: json.headers,
      cellDates: false,
      dateNF: 'm/d/yyyy h:mm:ss',
    });

    wb.SheetNames.push('report');
    wb.Sheets.report = ws;

    const wopts = {
      bookType: 'xlsx',
      bookSST: false,
      type: 'binary',
    };

    const wbout = XLSX.write(wb,wopts);

    /* the saveAs call downloads a file on the local machine */
    return new Blob([s2ab(wbout)],{type:"application/octet-stream"});
  }
}

// copied from js-xlsx browser example
function s2ab(s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i=0; i !== s.length; ++i)
    view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/csv-imports-exports/ExcelUtils.js